export default "__VITE_ASSET__f0959c0b__"